import React, { useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Modal from "react-bootstrap/Modal";
import ViewIcon from "../../BookModule/AdminSide/BookTabs/ViewIcon.png";
import Loader from "../../../Loader";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./ViewInterviewDetails.module.css";
import axios from "axios";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../labels";
import fileDownload from "js-file-download";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../../axios";
import { Chip, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import toast from "react-hot-toast";
import FloatedTitleContainer from "../../../../../ui/FloatedTitleContainer";
import { MEDIA_SIZE_LG } from "../../../../../utils/helper";
import moment from "moment";
// import { CSVLink } from "react-csv";
// import CustomDownloadButton from "../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";

function ViewInterviewDetails() {
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_type) {
      user_type = user.user_type;
    }
  } else {
    console.log("user not available in session storage");
  }
  const location = useLocation();
  const { batch_id, id } = useParams();
  const {
    INTERVIEWDATE,
    LASTDATE,
    RESULTSTATUS,
    ID,
    filStatus,
    CLASSMODE,
    PAGEFROM,
    TYPE,
    FSEARCH,
  } = location.state || {};
  const navigate = useNavigate();
  const csvLinkRef = useRef(null);
  const [csvData, setCsvData] = useState([]);
  const [isCsvLoading, setIsCsvLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const mode = localStorage.getItem("CLASSMODE");
  const [updateChipData, setUpdateChipData] = useState([]);
  const [otherAppBatch, setOtherAppBatch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [resultStatus, setResultStatus] = useState(false);
  const [tempStatusOn, setTempStatusOn] = useState([]);
  const [appliedStatusOn, setAppliedStatusOn] = useState([]);
  const [initialfields, setInitialfields] = useState({
    batch_id: "",
    batch_name: "",
    category_course_id: "",
    category: "",
    interview_id: "",
    interview_name: "",
    interview_date: "",
    last_dt_apply: "",
    student_count: "",
    panel_count: "",
    result_status: "",
    syllabus_url: "",
    original_url: "",
  });
  const [PanelList, setPanelList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSort, setSelectedSort] = useState("asc");
  const [isOpen, setIsOpen] = useState({
    status: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [perfomanceData, setPerfomanceData] = useState({
    isLoading: true,
    methodOfTest: 0,
    batchID: 0,
    eventID: 0,
    title: "",
    date: new Date(),
    firstName: "",
    lastName: "",
    ans_sheet_download_req: "",
    studentScore: null,
    cutOffScore: 0,
    studentCorePercentage: 0,
    cutoffPercentage: 0,
    totalQuestions: 0,
    totalMarks: 100,
    answeredQuestion: 0,
    unAnsweredQuestions: 0,
    correctQuestion: 0,
    inCorrectQuestions: 0,
    marksObtained: 0,
    classRank: 0,
    overallRank: 0,
    classStudents: 0,
    overallStudents: 0,
    squadDetails: [],
    testTypes: [],
    subjectsList: [],
    timeTakenSubjectList: [],
    perfomanceSelectType: -1,
    subjectWiseSelectType: -1,
    timeTakenSelectType: -1,
    selectLoading: false,
    maximumMarks: 100,
    panelMark: 0,
    slabMark: 0,
    rank: 0,
    averageMarks: {
      personality: 0,
      general_knowledge: 0,
      departmental_knowledge: 0,
      core_subject: 0,
      habit: 0,
      leadership: 0,
      communication: 0,
      problem_solving: 0,
      computer_proficiency: 0,
      logical_skill: 0,
    },
    staffMarks: [],
    interviewPerformance: {},
  });

  const handleClick = () => {
    navigate("/PanelInfoCreate", {
      state: {
        BATCH_ID: initialfields.batch_id,
        CATEGORY_COURSE_ID: initialfields.category_course_id,
        CATEGORY: initialfields.category,
        INTERVIEW_ID: initialfields.interview_id,
        INTERVIEW_NAME: initialfields.interview_name,
        INTERVIEW_DATE: initialfields.interview_date,
        OTHERAPPBATCH: otherAppBatch,
        CLASSMODE: CLASSMODE || mode,
        BATCH_NAME: initialfields.batch_name,
      },
    });
  };
  // Add this useEffect for outside click detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't close if clicking on filter elements
      const isFilterElement =
        event.target.closest(".filterBoxs_testlist") ||
        event.target.closest(".textHead_th.material-icons") ||
        event.target.closest('input[type="checkbox"]') ||
        event.target.closest("label") ||
        event.target.closest(".List-Button") ||
        event.target.closest(".ListBtnItems") ||
        event.target.closest("a") ||
        event.target.closest("button");

      if (isOpen.status && !isFilterElement) {
        // If popup is open and click is outside, close it
        // But keep the temporary selections as they were (don't apply them)
        setIsOpen({
          status: false,
        });
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen.status]);
  const handleFeedback = () => {
    navigate("/InterviewFeedbackList", {
      state: {
        BATCHID: initialfields.batch_id,
      },
    });
  };

  const handleNavigate = (panelId, markStatus) => {
    navigate(`/Viewpanel`, {
      state: {
        PANELID: panelId,
        MARKSTATUS: appliedStatusOn,
        BATCHID: initialfields.batch_id,
        INTERVIEWID: initialfields.interview_id,
        PANEL_MARK_STATUS: markStatus,
        SHOW_INTERVIEW_DETAILS: false,
        PAGE_FROM: PAGEFROM,
        TYPE: TYPE || "InterviewList",
        ID: ID,
      },
    });
  };

  // Initialize from location.state only once - FIXED
  useEffect(() => {
    // Handle all cases properly
    if (filStatus !== undefined) {
      // filStatus can be: undefined, null, empty array, or array with items
      const statusArray = Array.isArray(filStatus) ? filStatus : [];
      setAppliedStatusOn(statusArray);
      setUpdateChipData(statusArray);
      setTempStatusOn(statusArray);
    } else {
      // If filStatus is undefined, initialize with empty arrays
      setAppliedStatusOn([]);
      setUpdateChipData([]);
      setTempStatusOn([]);
    }

    setIsFiltersInitialized(true);
  }, [filStatus]);

  // Load data when appliedStatusOn changes
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, appliedStatusOn]);

  // Update loadListdata to accept filters parameter
  const loadListdata = (filtersToUse = appliedStatusOn) => {
    setIsLoading(true);

    // Prepare mark_status for API
    let markStatusParam = "";
    if (filtersToUse.length > 0) {
      markStatusParam = filtersToUse[0].id; // Get the first status id
    }

    const data = {
      id: parseInt(id),
      page: "",
      page_size: "",
      mark_status: markStatusParam,
    };

    AxiosInstance.post("api/mockinterview/interview/view", data)
      .then((res) => {
        if (res.data.status) {
          const fiata = res.data.data.panels;
          const data = res?.data?.data;
          const panels = data?.panels || [];
          const otherAppBatches = data?.other_applicable_batches || [];

          setOtherAppBatch(otherAppBatches);
          setIsPublished(
            panels.length > 0 && panels.every((p) => p.mark_status === 1)
          );
          setResultStatus(data?.result_status === 1);

          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          setPanelList(serialNumberAddedData);
          setInitialfields({
            batch_id: res.data.data.batch_id,
            batch_name: res.data.data.batch_name,
            category_course_id: res.data.data.category_course_id,
            category: res.data.data.category,
            interview_id: res.data.data.interview_id,
            interview_name: res.data.data.interview_name,
            interview_date: res.data.data.interview_date,
            last_dt_apply: res.data.data.last_dt_apply,
            student_count: res.data.data.student_count,
            panel_count: res.data.data.panel_count,
            result_status: res.data.data.result_status,
            syllabus_url: res.data.data.syllabus_url,
            original_url: res.data.data.original_url,
          });

          setPerfomanceData((prev) => ({
            ...prev,
            squadDetails: res.data.data.top_ten || [],
          }));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error loading interview data:", error);
        setIsLoading(false);
        toast.error("Failed to load interview data");
      });
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    const id = parseInt(value);

    if (typename === "NotYetUpdated" || typename === "Updated") {
      if (checked) {
        setTempStatusOn([{ id: id, name: name, type: "status" }]); // Single selection
      } else {
        setTempStatusOn([]);
      }
    }
  };

  // Fix handleFilter to properly initialize temp state
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        ...prevState,
        status: !prevState.status,
      }));
      // Initialize temp state with applied filters when opening
      if (!isOpen.status) {
        setTempStatusOn([...appliedStatusOn]); // Create a copy
      }
    }
  };

  const handleApplyFilter = (name) => {
    if (name === "status") {
      // Apply temporary filters
      setAppliedStatusOn([...tempStatusOn]);
      setUpdateChipData([...tempStatusOn]);

      // Close the filter dropdown
      setIsOpen({
        ...isOpen,
        status: false,
      });
    }
  };
  // Fix handleClear to only clear temporary selection and trigger API call
  const handleClear = (name) => {
    if (name === "status") {
      setTempStatusOn([]); // Clear temporary selection
      setIsOpen({
        ...isOpen,
        status: false,
      });

      // Apply empty filters immediately (clearing applied filters)
      setAppliedStatusOn([]);
      setUpdateChipData([]);

      // Trigger API call with empty filters
      loadListdata([]);
    }
  };

  const handleAllClear = () => {
    setAppliedStatusOn([]);
    setTempStatusOn([]);
    setUpdateChipData([]);
    setIsOpen({
      status: false,
      interview_date: false,
      last_date: false,
    });
  };

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  // Fix handleDelete to properly remove chips
  // Fix handleDelete to properly remove chips
  const handleDelete = (chipToDelete, index) => () => {
    // Create new arrays without the deleted chip
    const newAppliedFilters = appliedStatusOn.filter(
      (item) => item.id !== chipToDelete.id
    );

    // Remove from chips display - find by matching properties
    const newChipData = updateChipData.filter(
      (chip) => chip.id !== chipToDelete.id
    );

    // Update all states
    setAppliedStatusOn(newAppliedFilters);
    setUpdateChipData(newChipData);

    // Also update temp state if filter dropdown is open
    if (isOpen.status) {
      setTempStatusOn(newAppliedFilters);
    }

    // Trigger API call with updated filters
    loadListdata(newAppliedFilters);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${initialfields.syllabus_url}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };

  const SortSelectedBooks = (event, sortKey) => {
    event.preventDefault();
    let order = selectedSort === "asc" ? "desc" : "asc";
    setSelectedSort(order);
    let sortedList = [...PanelList].sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setPanelList(sortedList);
  };

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = PanelList?.slice(start, end) || [];
  const totalPages = Math.ceil(PanelList?.length / rowsPerPage);

  const handlePrev = (val) => {
    setCurrentPage(val);
  };

  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleBackFilter = () => {
    if (TYPE === 5) {
      navigate(`/ListInterviewDetails/${ID}`, {
        state: {
          filInterviewDate: INTERVIEWDATE,
          filLastDate: LASTDATE,
          filStatus: RESULTSTATUS, // Send current applied filters back
          BATCHID: ID,
          TYPE: TYPE,
          ID: ID,
          filCateSearch: FSEARCH,
        },
      });
    } else {
      navigate(`/Interviewlist`, {
        state: {
          filInterviewDate: INTERVIEWDATE,
          filLastDate: LASTDATE,
          filStatus: RESULTSTATUS,
          BATCHID: ID,
          TYPE: TYPE,
          filCateSearch: FSEARCH,
        },
      });
    }
  };

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSubmit = () => {
    const formattedDate = initialfields.interview_date
      ? new Date(initialfields.interview_date).toISOString().split("T")[0]
      : null;

    const createPublishResults = {
      interview_id: initialfields.interview_id,
      interview_date: formattedDate,
    };

    AxiosInstance.post("api/mockinterview/publish_result", createPublishResults)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          loadListdata();
        } else {
          toast.error(res.data.message);
          handleClose();
          loadListdata();
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!");
        handleClose();
      });
  };

  const SquadContainer = styled("div")`
    padding: 10px;
  `;

  const SquadContentBox = styled("div")`
    border: 1px solid var(--color-text-primary);
    border-radius: var(--border-radius-sm);
  `;

  const SquadRank = styled("p")`
    font-size: 32px;
    color: var(--color-brand-800);
    font-style: italic;
    margin: 0;
    @media (min-width: ${MEDIA_SIZE_LG}) {
      font-size: 64px;
    }
  `;

  const SquadImg = styled("img")`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
  `;

  const SquadName = styled("p")`
    font-size: 18px;
    font-weight: var(--font-weight-medium);
    color: var(--color-brand-800);
    text-transform: capitalize;
    margin: 8px 0;
  `;

  const SquadHeader = styled("p")`
    font-size: 14px;
    color: var(--color-text-secondary);
    text-transform: capitalize;
    margin: 0;
    margin-bottom: 8px;
  `;

  const SquadText = styled("p")`
    font-size: 16px;
    color: var(--color-text-primary);
    font-weight: var(--font-weight-bold);
    margin: 0;
    margin-bottom: 8px;
  `;

  const fetchInterviewResult = async () => {
    if (!initialfields.interview_id) {
      toast.error("Interview ID not available");
      return [];
    }

    const res = await AxiosInstance.post(
      "api/mockinterview/interview/csv_list",
      { interview_id: initialfields.interview_id }
    );

    if (!res?.data?.status || !Array.isArray(res.data.data)) {
      toast.error("No data available");
      return [];
    }

    return res.data.data;
  };

  const downloadCSV = async () => {
    if (isCsvLoading) return;

    try {
      setIsCsvLoading(true);

      const data = await fetchInterviewResult();
      if (!Array.isArray(data) || data.length === 0) {
        toast.error("No data available");
        return;
      }

      const formattedData = data.map((item, index) => ({
        "S.No": index + 1,
        "Student Name": item.full_name,
        Category: item.category,
        "Batch Name": item.batch_name,
        "Course Name": item.category_class,
        Panel: item.panel_name,
        "Interview Date": item.interview_date
          ? moment(item.interview_date).format("DD/MM/YYYY")
          : "",
        Location: item.location_name,
        "Attendance Status": item.attendance_status,
        "Total Mark": item.total_mark ?? "-",
        "Panel Mark": item.panel_mark ?? "-",
        "Slab Mark": item.slab_mark ?? "-",
        Rank: item.rank_no ?? "-",
        "Slab Remark": item.slab_remark ?? "-",
      }));

      const csv = Papa.unparse(formattedData);
      const blob = new Blob([csv], {
        type: "text/csv;charset=utf-8;",
      });

      saveAs(blob, "Interview_Result.csv");

      //     setTimeout(() => {
      //   if (csvLinkRef.current) {
      //     csvLinkRef.current.link.click();
      //   }
      // }, 0);
    } catch (error) {
      console.error("CSV download error", error);
      toast.error("CSV download failed");
    } finally {
      setIsCsvLoading(false);
    }
  };

  const downloadPDF = async () => {
    try {
      const data = await fetchInterviewResult();
      if (!data.length) return;

      if (data.length > 500) {
        toast.error(
          "PDF cannot be generated for more than 500 records. Please apply filters."
        );
        return;
      }

      const doc = new jsPDF("landscape");

      doc.setFontSize(14);
      doc.text("Interview Result Report", 14, 15);

      const headers = [
        "S.No",
        "Student Name",
        "Panel",
        "Attendance",
        "Slab Mark",
        "Rank",
      ];

      const rows = data.map((item, index) => [
        index + 1,
        item.full_name,
        item.panel_name,
        item.attendance_status,
        item.slab_mark ?? "-",
        item.rank_no ?? "-",
      ]);

      if (rows.length <= 500) {
        navigate("/preview", {
          state: {
            title: "Interview_Result",
            headers,
            rows,
            filename: "Interview_Result.pdf",
            autoPrint: true,
          },
        });
      } else {
        toast.error(
          "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
        );
      }

      // doc.autoTable({
      //   head: [headers],
      //   body: rows,
      //   startY: 25,
      //   styles: { fontSize: 9 },
      // });

      // doc.save("Interview_Result.pdf");
    } catch (error) {
      console.error("PDF download error", error);
      toast.error("Failed to generate PDF");
    }
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className={`${styles.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-2 col-12">
            <h2 className="TitleHeader">View Interview</h2>
          </div>
          <div className="col-md-10 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  onClick={handleBackFilter}
                  to="javascript:void(0)"
                  className="secondaryButton "
                  variant="secondary"
                >
                  {"Back to Interviews"}
                </Link>
              </li>

              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton ${
                    resultStatus || !isPublished ? `${styles.disabledBtn}` : ""
                  }`}
                  onClick={(e) => {
                    if (resultStatus && !isPublished) {
                      e.preventDefault();
                      return;
                    }
                    handleOpen();
                  }}
                >
                  Publish Result
                </Link>
              </li>
              {user_type === 1 && (
                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    className={`primaryButton ${
                      initialfields.student_count == 0 || resultStatus || !ID
                        ? `${styles.disabledBtn}`
                        : ""
                    }`}
                    onClick={(e) => {
                      if (resultStatus) {
                        e.preventDefault();
                        return;
                      }
                      handleClick();
                    }}
                  >
                    Create New Panel
                  </Link>
                </li>
              )}

              {/* Download as csv */}
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton ${
                    initialfields.result_status !== 1 || PanelList.length === 0
                      ? styles.disabledBtn
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      initialfields.result_status !== 1 ||
                      PanelList.length === 0 ||
                      isCsvLoading
                    )
                      return;

                    downloadCSV();
                  }}
                >
                  <span className="material-icons align-middle text-white">
                    file_download
                  </span>
                  {isCsvLoading ? "Downloading..." : "Download as CSV"}
                </Link>
              </li>

              {/* download as pdf */}
              <li
                className={`ListBtnItems primaryButton ${
                  initialfields.result_status !== 1 || PanelList.length === 0
                    ? styles.disabledBtn
                    : ""
                }`}
                onClick={() => {
                  if (
                    initialfields.result_status !== 1 ||
                    PanelList.length === 0
                  )
                    return;
                  downloadPDF();
                }}
              >
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>

              {/* Interview Feedback */}
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton ${
                    !resultStatus ? `${styles.disabledBtn}` : ""
                  }`}
                  onClick={(e) => {
                    if (!resultStatus) {
                      e.preventDefault();
                      return;
                    }
                    handleFeedback();
                  }}
                >
                  Interview Feedback
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Interview Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Interview Title</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields.interview_name || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Interview Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields?.interview_date
                      ? moment(initialfields.interview_date).format(
                          "DD/MM/YYYY"
                        )
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Last Date to Apply</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields?.last_dt_apply
                      ? moment(initialfields.last_dt_apply).format("DD/MM/YYYY")
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">
                      Upload Syllabus (in pdf/Image format):
                    </p>
                    {initialfields.syllabus_url !== "" &&
                      initialfields.syllabus_url !== null && (
                        <a
                          // href={`${ImageUrlPrefix}/${initialfields.original_preview_path}`}
                          to="javascript:void(0)"
                          onClick={() =>
                            handleDownload(
                              initialfields.syllabus_url,
                              initialfields.original_url
                            )
                          }
                          // target="_blank"
                          download
                        >
                          <span className="material-icons align-middle download_icon">
                            file_download
                          </span>
                        </a>
                      )}
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields.original_url || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Students Enrolled</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields.student_count ?? "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Number of Panels</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields.panel_count ?? "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Result Status</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {initialfields.result_status == 0
                      ? "Not Yet Published"
                      : "Published" || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
          <div className="row mt-3">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
              <fieldset className={styles.CourierContainer}>
                <legend className="w-auto mb-0">Panel Details</legend>
                {updateChipData?.length > 0 ? (
                  <div className="row mx-0">
                    <div className="col-md-12 px-0 col-sm-12 col-xs-12 paperil_global">
                      <Paper
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          listStyle: "none",
                          boxShadow: "none",
                          p: 0,
                          m: 0,
                        }}
                        component="ul"
                      >
                        {updateChipData.map((data, index) => {
                          let icon;
                          return (
                            <ListItem key={index}>
                              <Chip
                                icon={icon}
                                label={
                                  <span className={styles.BoldTyText}>
                                    {data.name}
                                  </span>
                                }
                                onDelete={handleDelete(data)}
                              />
                            </ListItem>
                          );
                        })}
                        <ListItem className="clearAll_list">
                          <a
                            className="clearAll_listItem"
                            href="javascript:void(0)"
                            onClick={handleAllClear}
                          >
                            Clear All Filters
                          </a>
                        </ListItem>
                      </Paper>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="row mx-0 mt-4">
                  <div className="col-md-12 table-responsive tableMinHeight px-0">
                    <table className="table" id="tableListHeader">
                      <thead>
                        <tr>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "serialNumber")
                              }
                            >
                              S.No.
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "serialNumber")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "panel_name")
                              }
                            >
                              Panel Name
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "panel_name")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "faculty_names")
                              }
                            >
                              Panel Experts
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "faculty_names")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "panel_student_count")
                              }
                            >
                              Student Enrolled
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "panel_student_count")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "core_subject")
                              }
                            >
                              Core Subject
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "core_subject")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "start_time")
                              }
                            >
                              Time
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "start_time")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "slot_duration")
                              }
                            >
                              Slot Duration in Minutes
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "slot_duration")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              className="textHead_th"
                              onClick={(e) =>
                                SortSelectedBooks(e, "mark_status")
                              }
                            >
                              Mark Status
                            </span>
                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                SortSelectedBooks(e, "mark_status")
                              }
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                appliedStatusOn.length > 0 || isOpen.status
                                  ? styles.active_icons_book
                                  : ""
                              } `}
                              onClick={(e) => handleFilter(e, "status")}
                            >
                              filter_list
                            </span>
                            {isOpen.status && (
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Not Yet Updated"}
                                        value={0}
                                        id={"NotYetUpdated"}
                                        checked={tempStatusOn.some(
                                          (element) => element.id === 0
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "NotYetUpdated",
                                            "NotYetUpdated"
                                          )
                                        }
                                      />
                                      <label
                                        className={`form-check-label filterChipText ms-3 ${styles.deliveryStatus} ${styles.deliveryStatusPink}`}
                                        htmlFor={"NotYetUpdated"}
                                      >
                                        Not Yet Updated
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Updated"}
                                        value={1}
                                        checked={tempStatusOn.some(
                                          (element) => element.id == 1
                                        )}
                                        id={"Updated"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "Updated",
                                            "Updated"
                                          )
                                        }
                                      />
                                      <label
                                        className={`form-check-label filterChipText ms-3 ${styles.deliveryStatus} ${styles.deliveryStatusGreen}`}
                                        htmlFor={"Updated"}
                                      >
                                        Updated
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("status")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={tempStatusOn.length === 0}
                                        onClick={() =>
                                          handleApplyFilter("status")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>
                          <th id="th" className={styles.tableThPadding}>
                            <span className="textHead_th">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentData?.length === 0 ? (
                          <tr>
                            <td colSpan="15" style={{ textAlign: "center" }}>
                              No records to display
                            </td>
                          </tr>
                        ) : (
                          Array.isArray(currentData) &&
                          currentData?.map((book, index) => (
                            <tr key={index}>
                              <td id="td">{book.serialNumber}</td>
                              <td id="td">
                                <span>{book.panel_name || "-"}</span>
                              </td>
                              <td id="td">
                                <span>{book.faculty_names || "-"}</span>
                              </td>
                              <td id="td">
                                <span>{book.panel_student_count ?? "-"}</span>
                              </td>
                              <td id="td">
                                <span>{book.core_subject || "-"}</span>
                              </td>
                              <td id="td">
                                <span>
                                  {`${book.start_time}-${book.end_time} `}
                                </span>
                              </td>
                              <td id="td">
                                <span>{book.slot_duration || "-"}</span>
                              </td>
                              <td id="td">
                                <span
                                  style={{ cursor: "auto" }}
                                  className={`filterChipText ${
                                    book.mark_status === 1
                                      ? "bg-green"
                                      : "bg-pink"
                                  }`}
                                >
                                  {book.mark_status == 0
                                    ? "Not Yet Updated"
                                    : "Updated" || "-"}
                                </span>
                              </td>
                              <td id="td">
                                <img
                                  src={ViewIcon}
                                  className={styles.cursor_pointer}
                                  onClick={() =>
                                    handleNavigate(
                                      book.panel_id,
                                      book.mark_status
                                    )
                                  }
                                  alt="view icon"
                                />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row mt-2">
                  <Pagination
                    rowsPerPage={rowsPerPage}
                    handlePageCount={handlePageCount}
                    startPage={PanelList?.length > 0 ? start + 1 : 0}
                    endPage={
                      PanelList?.length > 0
                        ? Math.min(end, PanelList?.length)
                        : 0
                    }
                    totalRecords={PanelList?.length}
                    handlePrev={handlePrev}
                    currentPrevPage={currentPage === 1}
                    prevButton={`${styles.prev_buttonViewAllbook} ${styles.materialIconsRightAndLeft} me-2`}
                    handleNext={handleNext}
                    currentNextPage={
                      currentPage >= totalPages || totalPages == 0
                    }
                  />
                </div>
              </fieldset>
            </div>
          </div>

          {!batch_id &&
            perfomanceData.squadDetails &&
            perfomanceData.squadDetails.length > 0 && (
              <FloatedTitleContainer title="Top 10 Squad">
                <div
                  className="row align-items-center mt-3 p-0"
                  style={{ margin: "20px 10px" }}
                >
                  {perfomanceData.squadDetails &&
                  perfomanceData.squadDetails.length > 0 ? (
                    perfomanceData.squadDetails.map((squad, index) => {
                      return (
                        <SquadContainer
                          className="col-12 col-md-6 m-0 "
                          key={index}
                        >
                          <SquadContentBox>
                            <div className="row p-1 m-0 justify-content-center align-items-center">
                              <div className="col-6 col-lg-2 m-0 p-0">
                                <div className="d-flex justify-content-center align-items-center">
                                  <SquadRank>{squad.event_rank}</SquadRank>
                                </div>
                              </div>
                              <div className="col-6 col-lg-3">
                                <SquadImg
                                  src={`${ImageUrlPrefix}/${
                                    squad.profile_path || ""
                                  }`}
                                  className="img-fluid"
                                  alt="student profile"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `${ImageUrlPrefix}/uploads/profiles/default-profile.png`;
                                  }}
                                />
                              </div>
                              <div className="col-12 col-lg-7">
                                <SquadName>{`${squad.first_name || ""} ${
                                  squad.last_name || ""
                                }`}</SquadName>
                                <div className="row p-0 m-0">
                                  <div className="col-6 p-0 m-0">
                                    <SquadHeader>Obtained Marks</SquadHeader>
                                    <SquadText>{`${squad.panel_mark || 0} / ${
                                      squad.Total_mark || 100
                                    }`}</SquadText>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SquadContentBox>
                        </SquadContainer>
                      );
                    })
                  ) : (
                    <div className="col-12 text-center">
                      <p>No squad data available</p>
                    </div>
                  )}
                </div>
              </FloatedTitleContainer>
            )}
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="ModalHeader mb-0">Publish Result</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4 col-md-12">
            <p className="text-start">
              Are you sure you want to publish the result for the interview
              titled <strong>{initialfields.interview_name}</strong> for{" "}
              {initialfields.interview_date
                ? new Date(initialfields.interview_date).toLocaleDateString(
                    "en-GB"
                  )
                : ""}
              ?
            </p>
            <div className="row mt-4">
              <div className="col-md-6">
                <p className="text-muted mb-1">Interview Title</p>
                <p className="fw-bold">{initialfields.interview_name}</p>
              </div>
              <div className="col-md-6">
                <p className="text-muted mb-1">Date</p>
                <p className="fw-bold">
                  {initialfields.interview_date
                    ? new Date(initialfields.interview_date).toLocaleDateString(
                        "en-GB"
                      )
                    : ""}
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end w-100">
            <button
              className={`${styles.dont_delete} bg-white secondaryButton border-0 mx-2`}
              onClick={handleClose}
            >
              View Interview
            </button>
            <button
              className="primaryButton border-0 mx-2"
              onClick={handleSubmit}
            >
              Publish Now
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ViewInterviewDetails;
